import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const FAQS = [
    { q: 'How much does The Room cost?', a: 'The Room is free for one church group during early access. There are no paid tiers today, and we will give plenty of notice before introducing any.' },
    { q: 'What is included for free?', a: 'Everything: courses and lessons, resources, discussion questions, group chat, direct messages, attendance tracking and live video meetings.' },
    { q: 'How do members join?', a: 'Leaders create a group and get a unique invite code. Members sign up with that code and the leader approves them.' },
    { q: 'Who can see our members and messages?', a: 'Only people in your group. Each group is kept separate, and leaders control who is approved.' },
    { q: 'Do I need a credit card?', a: 'No. You can start a group without any payment details.' },
];

export const PricingFaq = () => (
    <section id="faq" className="max-w-3xl mx-auto px-6 md:px-8 py-20 md:py-28 scroll-mt-20" data-testid="pricing-faq">
        <div className="mb-10 space-y-3">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-primary" style={{ fontFamily: "'Manrope', sans-serif" }}>Pricing & FAQ</p>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight" style={{ fontFamily: "'Fraunces', serif" }}>Free during early access</h2>
            <p className="text-muted-foreground" style={{ fontFamily: "'Manrope', sans-serif" }}>One church group, every feature, no credit card.</p>
        </div>
        <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
                <AccordionItem key={f.q} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
                    <AccordionTrigger className="text-left text-base" style={{ fontFamily: "'Manrope', sans-serif" }}>{f.q}</AccordionTrigger>
                    <AccordionContent className="text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
                </AccordionItem>
            ))}
        </Accordion>
    </section>
);

export default PricingFaq;
